<template>
  <div>
    <Offline />
    <Topbar />
    <Sidebar />

    <div class="app-content content">
      <div class="content-wrapper">
        <div class="content-wrapper-before"></div>
        <div class="content-header row"></div>
        <router-view/>
      </div>
    </div>

  </div>
</template>

<script>
import Sidebar from '@/components/navigation/Sidebar.vue'
import Topbar from '@/components/navigation/Topbar.vue'
import Offline from '@/components/navigation/Offline.vue'

export default {
  name: 'appLayout',
  components: {
    Sidebar,
    Topbar,
    Offline
  },
  /*
  updated: function () {
    $('body').attr('class', 'vertical-layout 2-columns fixed-navbar vertical-overlay-menu menu-hide pace-done').attr('data-col', '2-columns')
  },
  */
  mounted: function () {
    $('body').addClass('app-layout')

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.main-menu, .menu-toggle').length) {
        $.app.menu.hide()
      }
    })
  },
  beforeDestroy: function () {
    $('body').removeClass('app-layout')
  }

}
</script>

<style scoped>
#offline-order-counter {

}
</style>
